import { render, staticRenderFns } from "./FinanceiroPrincipal.vue?vue&type=template&id=650dd9be&scoped=true&"
import script from "./FinanceiroPrincipal.vue?vue&type=script&lang=js&"
export * from "./FinanceiroPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650dd9be",
  null
  
)

export default component.exports